//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';

let namespace = 'purrecordorder_';

const initialState = {  
	  data:[],
	  dataLoading: true,	  
	  dataFetchProps: {order:[['id','desc']],status:'推送成功',include:[{model:'pur_record_file',as:'m_recordOrderFile',attributes:['id','contract_local_url','status','attachmenttype','contract_bank_url']}]},
      modalVisible: false,
	  modalType: 'create',
	purRecordOrderDetailVisible: false,
	  pwdModalVisible: false,
	  selectedRow: {},
	  selectedRowIndex: -1,  
	  selectedRows: [],  
	  clickRow:{},
      selectedRowKeys: [],
	  offset:0,
	  limit:0,
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,		 
		},	  
	  
	  
}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {		
	
      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {
		
		let newData = state.data
		
		let {selectedRowIndex, id} = action.payload		
		
		newData[selectedRowIndex] = action.payload.data		
		
		return {...state, selectedRow: action.payload.data, data: newData}
	}

	case namespace+"deleteDataById": {
		
		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)
		
		return {...state, data: newData}
	}
	
	case namespace+"addOneRowData": {
		
		return {...state, data: [action.payload.data, ...state.data]}
	}
	
	case namespace+"RemoveDataByIndex": {
		
		let newData = state.data;		
		let {selectedRowIndex} = action.payload		
		newData.splice(selectedRowIndex,1)
		
		return {...state, data: newData}
	}
	
    default:
      return state;
  }
}